$eve_app_page_components_switch $eve_app_page_sb_page
	title \Switch
	Head null
	body /
		<= Switch_catalog $eve_app_page_sb_catalog
			param \switch
			spreads *
				bare <= Bare_page $eve_app_page_sb_page
					title \Bare
					body /
						<= Bare_playground $eve_app_page_sb_playground
							component_name \Live_switch
							default_source \
								\Live_switch $eve_switch
								\	checked? true
								\	disabled? false
								\
				labelled <= Labelled_page $eve_app_page_sb_page
					title \Labelled
					body /
						<= Labelled_playground $eve_app_page_sb_playground
							component_name \Live_switch_labelled
							default_source \
								\Live_switch_labelled $eve_switch_labelled
								\	size? \m
								\	checked? true
								\	disabled? false
								\	label \Enable notifications
								\

